// EN
export const reservasSmallHc = {
  createAlerta: {
    title: "Create new reminder",
    infoHeading: "Reminder information",
    selectPropertyLabel: "Select the property you want to assign the reminder to",
    dayLabel: "Select a day of the week:",
    dayMonday: "Monday",
    dayTuesday: "Tuesday",
    dayWednesday: "Wednesday",
    dayThursday: "Thursday",
    dayFriday: "Friday",
    daySaturday: "Saturday",
    daySunday: "Sunday",
    selectTimeLabel: "Select the time",
    sendAtLabel: "It will be sent at:",
    minutesLabel: "With {minutes} minutes:",
    previewPre: "The alert will be sent to guests on",
    previewMid: "at",
    descriptionLabel: "Alert description",
    descriptionPlaceholder: "Enter a description for the alert",
    messageTypeLabel: "Select the type of message to send.",
    messageTypeSimple: "Simple message",
    messageTypeLink: "Message with a link at the end",
    messageTypeFile: "Message with an attached file at the end",
    linkFieldLabel: "Enter the link to send with the reminder",
    fileFieldLabel: "Upload the file to send with the reminder",
    fileNameLabel: "File name",
    cancel: "Cancel",
    save: "Save reminder",
    errorDayRequired: "The day is required",
    errorTimeRequired: "The time is required",
    errorSelectMinutes: "Select the minutes",
    errorDescriptionRequired: "The description is required",
    errorAttachmentRequired: "The attachment is required, or set the message type to simple",
  },
  reservationData: {
    statusConfirmed: "Confirmed",
    statusRejected: "Rejected",
    statusTentative: "Subject to availability",
    statusWithinCheckin: "Within check-in hours",
    statusFree: "No charge",
    modalTitleApprove: "Approve the request?",
    modalTitleApproveTime: "Approve at a different time?",
    modalTitlePrioritize: "Prioritize this check-in?",
    modalTitleReject: "Reject the request?",
    modalTitleDefault: "Confirm?",
    modalTextApprove: "You are going to approve the early check-in for",
    modalTextApproveTime: "You will confirm the check-in at the time you specify for",
    modalTextPrioritize: "We'll tell them you'll do everything you can to have it ready by then, although it depends on the previous checkout and the cleaning. It will be sent to",
    modalTextReject: "You are going to reject the early check-in for",
    modalTextDefault: "Confirm for",
    modalCtaApprove: "Yes, approve",
    modalCtaApproveTime: "Confirm time",
    modalCtaPrioritize: "Yes, inform",
    modalCtaReject: "Yes, reject",
    modalCtaDefault: "Confirm",
    kpiRoom: "Room",
    kpiLodging: "Accommodation",
    guestsCount: "guest | guests",
    adultsCount: "adult | adults",
    childrenCount: "child | children",
    infantsCount: "infant | infants",
    roomsCountValue: "{count} rooms",
    holderRole: "Booking holder",
    noEmail: "No email assigned",
    writeWhatsapp: "Message on WhatsApp",
    noPhoneTitle: "Without a phone number it cannot be sent via WhatsApp. You can add it in «Edit booking».",
    noPhone: "No phone assigned",
    kpiCheckin: "Check-in",
    kpiCheckout: "Check-out",
    earlyRequested: "Early check-in requested",
    arrivalRequested: "Arrival time requested",
    arrivesAt: "Arrives at {time}",
    actionApprove: "Approve",
    actionOtherTime: "Another time",
    actionPrioritize: "Prioritize",
    actionReject: "Reject",
    awaitingPayment: "Waiting for the guest to pay",
    cannotUndo: "This action cannot be undone.",
    checkinTimeLabel: "Check-in time",
    earlyPrioritisedTitle: "Early check-in prioritised",
    earlyApprovedTitle: "Early check-in approved",
    earlyRejectedTitle: "Early check-in declined",
    earlyLineApproved: "Will arrive at {time}",
    earlyLineApprovedOther: "Will arrive at {time} · asked for {original}",
    earlyLineRejected: "Asked for {time} · will check in at the usual time",
    earlyLineRejectedStd: "Asked for {time} · will check in at the usual time ({std})",
    earlyLinePrioritised: "Wants to arrive at {time} · told we'll do our best",
    extRequestedTitle: "Stay extension requested",
    extAwaitingTitle: "Stay extension awaiting payment",
    extConfirmedTitle: "Stay extension confirmed",
    extNights: "Nights added: {nights} · new check-out {date}",
    extAtProperty: "{amount} to pay at the property",
    extPendingHost: "awaiting your approval",
    lateRequestedTitle: "Late check-out requested",
    lateAwaitingTitle: "Late check-out awaiting payment",
    lateConfirmedTitle: "Late check-out confirmed",
    lateRejectedTitle: "Late check-out declined",
    lateLeavesAt: "Leaves at {time}",
    lateWantsToLeave: "Wants to leave at {time}",
    lateInsteadOf: "(instead of {std})",
    latePaid: "Paid: {amount}",
    lateCourtesy: "Courtesy hour, free of charge",
    lateFree: "Free of charge",
    lateCash: "{amount} in cash at check-out",
    lateUnpaid: "{amount}, not paid yet",
    lateLineRejected: "Asked to leave at {time} · leaves at the usual time",
    lateLineRejectedStd: "Asked to leave at {time} · leaves at the usual time ({std})",
    requestedTimeHint: "The guest asked for {time}",
    toastApproved: "Early check-in approved",
    toastApprovedTime: "New check-in time approved",
    toastPrioritised: "Early check-in prioritised",
    toastRejected: "Early check-in declined",
    toastNotified: "We've already messaged the guest.",
    toastNotNotified: "We couldn't notify the guest: please message them yourself.",
    toastAlreadyDecided: "This request was already decided: the guest wasn't messaged again.",
    toastError: "Couldn't save the decision. Please try again.",
    toastAlreadyPaid: "It was already paid: they weren't charged again.",
    toastRefundMaybeDue: "They paid to check in early and now arrive at the usual time: refund them if appropriate.",
    actionReadyNow: "Ready: they can check in",
    actionNotPossible: "It won't be possible",
    toastPaymentLinkFailed: "The payment link couldn't be created: please charge it another way.",
    arrivalApprovedTitle: "Arrival time confirmed",
    arrivalRejectedTitle: "Arrival time declined",
    arrivalLineRejected: "Asked to arrive at {time}",
    modalTextApproveArrival: "You're about to confirm the arrival time of",
    modalTextRejectArrival: "You're about to decline the arrival time of",
    toastArrivalApproved: "Arrival time confirmed",
    toastArrivalRejected: "Arrival time declined",
    cancel: "Cancel",
  },
  minStayModal: {
    summaryNoData: "No data in the selected range",
    summaryHintMixed: "Several minimum stays were detected in the range. The field is set to 1 night so you can define the new value.",
    summaryHintSingle: "The field was loaded with the current minimum stay for the selected range.",
    errorMinOne: "The minimum stay must be at least 1 night.",
    opStartLabel: "Changing minimum stay…",
    successUpdated: "Minimum stay updated successfully",
    errorUpdate: "Error updating the minimum stay",
    errorUnknown: "Unknown error",
    title: "Minimum stay",
    description: "Set the minimum stay in nights for the selected date range.",
    detectedLabel: "Minimum stays detected",
    minStayLabel: "Minimum stay (nights)",
    decreaseAria: "Decrease minimum stay",
    minNightsPlaceholder: "e.g. 2",
    increaseAria: "Increase minimum stay",
    hint: "Minimum number of nights the guest must book.",
    cancel: "Cancel",
    save: "Save",
  },
  modalCompleteReservation: {
    errorContactRequired: "To continue you must fill in one of the two fields (phone or email)",
    successMsg: "Booking details completed successfully",
    successTitle: "Process completed successfully",
    title: "Complete booking",
    bookingDateLabel: "Booking dates",
    checkin: "Check-in",
    checkout: "Check-out",
    phoneRequiredHint: "* Only required field",
    emailHint: "*If you provide the email, the guest will not have to enter it",
    responsibleLabel: "Enter the name of the person responsible",
    responsiblePlaceholder: "Person responsible for the booking",
    scheduleLabel: "Schedule the send date for the check-in link.",
    scheduleAuto: "Automatic sending",
    schedule24: "24 hours before check-in",
    schedule48: "48 hours before check-in",
    schedule72: "72 hours before check-in",
    scheduleWeek: "One week before check-in",
    cancel: "Cancel",
    complete: "Complete booking",
  },
  payData: {
    errorNoPaymentRecord: "The payment record could not be identified.",
    partialLinkGenerated: "Payment link generated successfully.",
    errorGenerateLink: "The link could not be generated.",
    partialRegistered: "Partial payment recorded.",
    errorSavePartial: "The partial payment could not be saved.",
    whatsappPartialMsg: "Hi {name}, here is the link to complete the outstanding payment for your booking: {url}",
    errorInvoicingNotActive: "Electronic invoicing is not enabled on your plan.",
    fieldBillingProfile: "Billing profile",
    fieldCountry: "Country",
    fieldLegalName: "Legal name",
    fieldTaxId: "NIF/CIF/NIT",
    fieldAddressStreet: "Address",
    fieldAddressCity: "City",
    fieldAddressRegion: "Region",
    fieldAddressZip: "Postal code",
    fieldEmail: "Email",
    fieldIsActive: "Activate profile",
    errorBillingIncomplete: "Complete your billing details. Missing: {fields}",
    invoiceLinkCopied: "Invoicing link copied.",
    reservationHasInvoice: "This booking already has an invoice.",
    errorLoadReceipt: "The receipt could not be loaded.",
    errorDownloadReceipt: "The receipt could not be downloaded.",
    guestOutOfWindow: "The guest is outside the 24h WhatsApp window.",
    errorSendReceipt: "Error sending the receipt.",
    charge: "Charge",
    lodging: "Accommodation",
    servicesExtras: "Services and extras",
    free: "Free",
    ivaIncluded: "(VAT {rate}% included)",
    includedInPrice: "(included in the price)",
    pendingCharge: "Pending payment",
    viewBreakdown: "View price breakdown",
    viewReceipt: "View receipt",
    receiptInfoPre: "Informational receipt. The electronic invoice is issued from the tab",
    chargesTab: "Charges",
    receiptInfoNoInvoice: "Informational receipt available. For electronic invoicing, set up your billing details.",
    reservationNumber: "Booking #{code}",
    currentStatus: "Current status",
    willChangeTo: "Will change to:",
    saving: "Saving…",
    breakdownTitle: "Price breakdown",
    discounts: "Discounts",
    taxesAndFees: "Taxes and fees",
    ivaIncludedInPrice: "VAT ({rate}%) included in the price: {amount}",
    includesTaxes: "Includes {amount} of taxes included in the price",
    total: "Total",
    close: "Close",
    loadingReceipt: "Loading receipt…",
    stayReceipt: "Stay receipt · {date}",
    downloadPdf: "Download PDF",
    sending: "Sending…",
    sent: "Sent!",
    outOfWindow: "Outside 24h window",
    sendWhatsapp: "Send via WhatsApp",
    stayDetail: "Stay details",
    ivaIncludedShort: "VAT {rate}% included",
    discount: "Discount",
    nightsCount: "night | nights",
    additionalCharges: "Additional charges",
    ivaShort: "VAT {rate}%",
    charged: "Collected",
    pending: "Pending",
    receiptGeneratedBy: "Receipt generated by",
    done: "Done",
    registerPartial: "Record partial payment",
    reservationTotal: "Booking total",
    amountReceived: "Amount already received",
    paid: "Paid",
    pendingBalance: "Outstanding balance",
    amountExceedsTotal: "The amount received exceeds the total. Use the status",
    paidStatus: "Paid",
    internalNote: "Internal note",
    optional: "(optional)",
    notePlaceholder: "e.g. First payment received by bank transfer...",
    autoLinkNote: "On saving, the payment link will be automatically updated to",
    cancel: "Cancel",
    savePartial: "Save partial payment",
    roomsCount: "{count} room | {count} rooms",
    groupNotePre: "Amount for the",
    groupNoteCombined: "combined booking",
    groupNoteMid: "breakdown by room below.",
  },
};
